module.exports = __webpack_public_path__ + "img/symbol_17.bfe5abf2.png";